const Path = ({ path, setPath }) => {

    const Display = () => {
        return [{ name: "Mon espace", id:"0"}, ...path].map((item, index) => {
            const name = item.name.charAt(0).toUpperCase() + item.name.slice(1);
            const handleClick = () => {
                setPath(old => [...old].filter((p, i) => i < index));
            }
            return <button key={item.id} className={index !== 0 ? "" : "second"} onClick={handleClick}>
                {name}
            </button>})
    }

    return <span>
        <Display />
    </span>

}

export default Path;